import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PDFViewerModal = ({ url, buttonLabel, pdfTitle }: { url: string, buttonLabel: string, pdfTitle: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>
        {buttonLabel}
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { height: '90vh' } }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{pdfTitle}</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Box sx={{ flex: 1, height: '100%', overflow: 'hidden', px: 2, pb: 2 }}>
          <iframe src={url} title="PDF" width="100%" height="100%" style={{ border: 'none' }} />
        </Box>
      </Dialog>
    </>
  );
};

export default PDFViewerModal;
